import { PropTypes } from 'prop-types';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from 'antd';

const ResetPassword = ({ loading, onSubmit, email, isEmailDisabled }) => {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    getValues,
  } = useForm({});

  return (
    <>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        {email ? (
          <div className="form-group">
            <label>
              Email <span className="login-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              value={email}
              disabled={isEmailDisabled}
              readOnly
              autoComplete="email"
            />
          </div>
        ) : null}
        <div className="form-group">
          <label>
            Code <span className="login-danger">*</span>
          </label>
          <input
            className="form-control"
            type="text"
            autoComplete="one-time-code"
            {...register('code', { required: true })}
          />
          <small style={{ color: 'red' }}>
            {errors.code && <p>Please enter the code</p>}
          </small>
        </div>
        <div className="form-group">
          <label style={{ zIndex: "999" }}>
            New Password <span className="login-danger">*</span>
          </label>
          <Controller
            name="password"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input.Password
                {...field}
                className="form-control display-flex"
                autoComplete="new-password"
              />
            )}
          />
          <small style={{ color: 'red' }}>
            {errors.password && <p>Please enter new password</p>}
          </small>
        </div>
        <div className="form-group">
          <label style={{ zIndex: "999" }}>
            Comfirm Password <span className="login-danger">*</span>
          </label>
          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              required: 'Please Enter Confirm Password',
              validate: (match) => {
                const password = getValues('password');
                return match === password || 'Passwords should match!';
              },
            }}
            render={({ field }) => (
              <Input.Password
                {...field}
                className="form-control display-flex"
                autoComplete="new-password"
              />
            )}
          />
          <small style={{ color: 'red' }}>
            {errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}
          </small>
        </div>
        <div className="form-group login-btn">
          <button
            className="btn btn-primary btn-block"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Changing Password...' : 'Change Password'}
          </button>
        </div>
      </form>
    </>
  );
};

ResetPassword.propTypes = {
  email: PropTypes.string,
  isEmailDisabled: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ResetPassword.defaultProps = {
  email: undefined,
  isEmailDisabled: true,
};

export default ResetPassword;
